import {Component, OnInit} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAboutComponent } from '@app/modules/shared/modal/modal-about/modal-about.component';
import { environment } from '@env/environment';
import { ApiService } from '@app/modules/shared/services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
    currentLanguage;
    config;
    socialSettings;
    constructor(private translocoService: TranslocoService,
         private modalService: NgbModal,
         private apiService: ApiService) {
        this.currentLanguage = this.translocoService.getActiveLang();
    }

    ngOnInit(): void {
        this.config = environment.client;
        this.apiService.getSocialSettings().subscribe(response => {
          this.socialSettings = response.data;
         });

    } 
    changeLang(newLang: string) {
        this.translocoService.setActiveLang(newLang);
        localStorage.setItem('ss_user_lang', newLang);
        this.currentLanguage = newLang;
      }
      openAboutModal () {
        const modal = this.modalService.open(ModalAboutComponent, { size: 'lg'});
        modal.result.then((data) => {});
      }
}